/*
 * 类别
 *
 * @Author:    1024创新实验室-主任：卓大
 * @Date:      2022-09-03 22:07:51
 * @Wechat:    zhuda1024
 * @Email:     lab1024@163.com
 * @Copyright  1024创新实验室 ( https://1024lab.net )，Since 2012
 */
export const CATEGORY_TYPE_ENUM = {
  GOODS: {
    value: 1,
    desc: '商品',
  },
  DEMO: {
    value: 2,
    desc: '演示分类',
  },
};

export default {
  CATEGORY_TYPE_ENUM,
};
